import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  Collapse,
  Button,
  Progress,
  Space
} from '@lockerpm/design';

import {
  LeftOutlined,
  RightOutlined
} from "@ant-design/icons";

import {
  green
} from '@ant-design/colors';

import CollapseHeader from "./CollapseHeader";

import rewardServices from "../../../../services/reward";
import global from "../../../../config/global";

const DesktopInstallation = (props) => {
  const { t } = useTranslation();
  const stepNumber = 2;

  const {
    className,
    missionSteps = [],
    mission = {},
    verify = () => {},
    resubmit = () => {}
  } = props;

  const [collapseKeys, setCollapseKeys] = useState([])
  const [callingAPI, setCallingAPI] = useState(false)
  const [stepIndex, setStepIndex] = useState(0)
  const [percent, setPercent] = useState(0)

  const missionStep = useMemo(() => {
    const step = missionSteps.find(
      s => s.value === mission?.status
    )
    return step || missionSteps[0]
  }, [mission])

  useEffect(() => {
    if (missionStep.key === 1) {
      setStepIndex(0)
    } else {
      setStepIndex(stepNumber - 1)
    }
  }, [missionStep])

  useEffect(() => {
    if (missionStep.key === 3) {
      setPercent(100)
    } else {
      setPercent(stepIndex / stepNumber * 100)
    }
  }, [stepIndex, missionStep])

  const handleSend = async () => {
    const action = t('rewards.desktop_installation.title');
    const store = 'extension';
    setCallingAPI(true);
    await rewardServices.mission_completed(
      mission.mission.id,
      { user_identifier: null }
    ).then((res) => {
      if (res.claim) {
        verify({
          action,
          percent: 5,
        })
      } else {
        resubmit({
          action,
          store,
        })
      }
    }).catch(() => {
      resubmit({
        action,
        store,
      })
    })
    setCallingAPI(false);
  }

  return (
    <div className={`desktop-installation ${className}`}>
      <Collapse
        activeKey={collapseKeys}
        expandIconPosition={'end'}
        onChange={setCollapseKeys}
      >
        <Collapse.Panel
          key="1"
          header={<CollapseHeader
            title={t('rewards.desktop_installation.title')}
            percent={5}
            missionStep={missionStep}
            collapseKeys={collapseKeys}
            Right={(props) => {
              return <a
                className={props.className}
                href={global.urls.DESKTOP_DOWNLOAD}
                target="_blank"
              >
                <Button
                  type="primary"
                >
                  {t('rewards.desktop_installation.header_btn') }
                </Button>
              </a>
            }}
          />}
        >
          <div>
            <div className="lg:w-full md:w-full mb-4">
              {t('rewards.desktop_installation.subtitle')}
            </div>
            <div className={`mission-steps ${className}`}>
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center">
                  <p className="text-l font-semibold mr-4">{t('common.steps')}:</p>
                  <Progress
                    steps={stepNumber}
                    percent={percent}
                    showInfo={false}
                    strokeColor={green[6]}
                  />
                </div>
                {
                  missionStep.key !== 3 && <Space size={[12, 12]}>
                    <Button
                      type="text"
                      disabled={stepIndex === 0}
                      icon={<LeftOutlined />}
                      onClick={() => setStepIndex(stepIndex - 1)}
                    />
                    <Button
                      type="text"
                      disabled={stepIndex === stepNumber - 1}
                      icon={<RightOutlined />}
                      onClick={() => setStepIndex(stepIndex + 1)}
                    />
                  </Space>
                }
              </div>
              {
                stepIndex === 0 && <p>{t('rewards.desktop_installation.step1')}</p>
              }
              {
                stepIndex === 1 && <div>
                  <p>{t('rewards.desktop_installation.step2')}</p>
                  <Button
                    className="mt-4"
                    size="medium"
                    disabled={missionStep.key == 3}
                    type={missionStep.key == 3 ? undefined : 'primary'}
                    loading={callingAPI}
                    onClick={() => handleSend()}
                  >
                    {t('rewards.desktop_installation.btn')}
                  </Button>
                </div>
              }
            </div>
          </div>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}

export default DesktopInstallation;